import { DatePicker } from 'antd';
import React, { useState, useEffect, useRef } from 'react';
import { createHoliday } from '../../../service/holidayService';
import propTypes from 'prop-types';
import { Spin ,notification} from "antd";
import Select from 'react-select';
import dayjs from 'dayjs';
import moment from 'moment';
import { getAllHolidays } from '../../../service/holidayService';

const AddHolidays = ({ onHolidayAdded }) => {
    const [name, setName] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [status, setStatus] = useState(true);
    const [duration, setDuration] = useState(0);
    const [academic, setAcademic] = useState(null);
    const [otType, setOtType] = useState(null);
    const [loading, setLoading] = useState(false);
    const [dateRange, setDateRange] = useState([]);
    const selectRef = useRef(null);

    const leaveDayOptions = [
        { value: "Full Day", label: "Full Day", dayValue: 1 },
        { value: "Half Day-Morning", label: "Half Day/Morning", dayValue: 0.5 },
        { value: "Half Day-Evening", label: "Half Day/Evening", dayValue: 0.5 },
        { value: "Flexible", label: "Flexible", dayValue: 1 },
    ];

    // Calculate duration based on dateRange dayValues
    useEffect(() => {
        if (startDate && endDate && dateRange.length > 0) {
            if (endDate.isBefore(startDate, 'day')) {
                showWarning('End date cannot be earlier than start date.');
                setEndDate(null);
                setDuration(0);
                setDateRange([]);
            } else {
                // Sum the dayValue for each day in dateRange
                const totalDuration = dateRange.reduce((sum, day) => {
                    return sum + (day.dayValue || 0); // Use dayValue, default to 0 if not set
                }, 0);
                setDuration(totalDuration);
            }
        } else {
            setDuration(0);
        }
    }, [startDate, endDate, dateRange]);

    const handleStartDateChange = (date) => {
        setStartDate(date);
    };

    const formatDate = (date) => {
        const d = new Date(date);
        let month = "" + (d.getMonth() + 1);
        let day = "" + d.getDate();
        const year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        return [year, month, day].join("-");
    };

    const handleEndDateChange = async (date) => {
        setEndDate(date);
        if (startDate && date) {
            const start = startDate.$d;
            const end = date.$d;
            const daysArray = [];
            let currentDate = new Date(start);
            while (currentDate.getTime() <= end.getTime()) {
                daysArray.push({
                    date: formatDate(currentDate),
                    day: null,
                    dayValue: 1, // Default to Full Day (1 day)
                });
                currentDate.setDate(currentDate.getDate() + 1);
            }
            setDateRange(daysArray);
        } else {
            setDateRange([]);
        }
    };

    const handleLeaveTypeChange = (index, selectedOption) => {
        const updatedLeaveDays = [...dateRange];
        updatedLeaveDays[index].day = selectedOption.value;
        updatedLeaveDays[index].dayValue = selectedOption.dayValue; // Store dayValue
        setDateRange(updatedLeaveDays);
    };

    const handleStatusChange = (e) => {
        setStatus(e.target.checked);
    };

    const handleSelectChange = (option) => {
        setAcademic(option ? option.value : null);
    };

    const handleOtTypeChange = (option) => {
        setOtType(option ? option.value : null);
    };

    const options = [
        { value: "Academic", label: "Academic" },
        { value: "Non Academic", label: "Non Academic" },
        { value: "Common", label: "Common (Academic & Non-Academic)" }
    ];

    const otOptions = [
        { value: "Normal", label: "Normal" },
        { value: "Double", label: "Double" },
    ];

    const search = "";
    const [data, setData] = useState([]);
    const [, setFilteredData] = useState([]);

    const fetchHolidays = async (search = '') => {
        await getAllHolidays({
            search,
            setData: setData,
        });
    };

    useEffect(() => {
        const fetchAndFilterHolidays = async () => {
            if (startDate || endDate) {
                await fetchHolidays(search);
                let filtered = data;
                if (startDate) {
                    const startMonth = moment(startDate.toDate()).month();
                    filtered = filtered.filter(date =>
                        moment(date.startDate).month() === startMonth
                    );
                }
                if (endDate) {
                    const endMonth = moment(endDate.toDate()).month();
                    filtered = filtered.filter(date =>
                        moment(date.startDate).month() === endMonth
                    );
                }
                setFilteredData(filtered);
            } else {
                setFilteredData([]);
            }
        };
        fetchAndFilterHolidays();
    }, [startDate, endDate]);

    const handleSubmit = async () => {
        if (!name || !startDate || !endDate || academic === null) {
            showWarning("Please fill in the required fields.");
            return;
        }

        const holiday = {
            name,
            startDate: formatDate(startDate),
            endDate: formatDate(endDate),
            status,
            duration,
            holidayType: academic,
            daysDetail: dateRange,
            otPayment: otType
        };

        try {
            setLoading(true);
            const response = await createHoliday(holiday);
            onHolidayAdded(holiday);
            handleReset();
            setLoading(false);
            if (response.status === "success") {
                showSuccess();
            }
        } catch (error) {
            console.error('Error adding holiday:', error);
        }
    };

    const handleReset = () => {
        setName('');
        setStartDate(null);
        setEndDate(null);
        setStatus(true);
        setDuration(0);
        setAcademic(null);
        setDateRange([]);
        setOtType(null);
        if (selectRef.current) {
            selectRef.current.clearValue();
        }
    };

    const showWarning = (message) => {
        notification.error({
            message: 'Error',
            description: message,
            placement: 'topRight',
        });
    };

    const showSuccess = () => {
        notification.success({
            message: 'Success',
            description: 'Successfully Saved!',
            placement: 'topRight',
        });
    };

    return (
        <div>
            <div className="modal fade" id="add-department">
                <div className="modal-dialog modal-dialog-centered custom-modal-two">
                    <div className="modal-content">
                        <div className="page-wrapper-new p-0">
                            <div className="content">
                                <div className="modal-header border-0 custom-modal-header">
                                    <div className="page-title">
                                        <h4>Add Holiday</h4>
                                    </div>
                                </div>
                                <div className="modal-body custom-modal-body">
                                    <form>
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="mb-3">
                                                    <label>Add Holiday</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={name}
                                                        onChange={(e) => setName(e.target.value)}
                                                    />
                                                </div>
                                                <div className="col-12">
                                                    <div className="input-blocks">
                                                        <label>Select Holiday Type</label>
                                                        <Select
                                                            ref={selectRef}
                                                            className='select'
                                                            options={options}
                                                            placeholder="Select holiday type"
                                                            onChange={handleSelectChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="input-blocks">
                                                    <label>Start Date</label>
                                                    <div className="input-groupicon calender-input">
                                                        <DatePicker
                                                            value={startDate}
                                                            onChange={handleStartDateChange}
                                                            type="date"
                                                            className="filterdatepicker"
                                                            dateFormat="dd-MM-yyyy"
                                                            placeholder='20-2-2024'
                                                            getPopupContainer={(trigger) => trigger.parentNode}
                                                            defaultPickerValue={endDate || dayjs()}
                                                            style={{
                                                                width: "100%",
                                                                boxSizing: "border-box"
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="input-blocks">
                                                    <label>End Date</label>
                                                    <div className="input-groupicon calender-input">
                                                        <DatePicker
                                                            value={endDate}
                                                            onChange={handleEndDateChange}
                                                            type="date"
                                                            className="filterdatepicker"
                                                            dateFormat="dd-MM-yyyy"
                                                            placeholder='20-2-2024'
                                                            getPopupContainer={(trigger) => trigger.parentNode}
                                                            defaultPickerValue={startDate || dayjs()}
                                                            style={{
                                                                width: "100%",
                                                                boxSizing: "border-box"
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {dateRange.map((item, index) => (
                                                <div key={index} className="col-lg-12">
                                                    <div className="apply-leave">
                                                        <div className="leave-apply">
                                                            <div className="leave-date">
                                                                <p>{item.date}</p>
                                                            </div>
                                                            <div style={{ width: '100%' }}>
                                                                <div className="input-blocks mb-0">
                                                                    <Select
                                                                        className="select"
                                                                        options={leaveDayOptions}
                                                                        placeholder="Select holiday type"
                                                                        onChange={(selectedOption) =>
                                                                            handleLeaveTypeChange(index, selectedOption)
                                                                        }
                                                                        style={{ width: '100%' }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                            <div className="col-12">
                                                <div className="input-blocks">
                                                    <label>Select OT Payment Type</label>
                                                    <Select
                                                        ref={selectRef}
                                                        className='select'
                                                        options={otOptions}
                                                        placeholder="Select OT Payment"
                                                        onChange={handleOtTypeChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="input-blocks">
                                                    <label>No of Days</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder={duration}
                                                        value={duration}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            <div className="input-blocks m-0 pb-1">
                                                <div
                                                    className="status-toggle modal-status d-flex justify-content-between align-items-center">
                                                    <span className="status-label">Status</span>
                                                    <input
                                                        type="checkbox"
                                                        id="user5"
                                                        className="check"
                                                        checked={status}
                                                        onChange={handleStatusChange}
                                                    />
                                                    <label htmlFor="user5" className="checktoggle">
                                                        {" "}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }} className="mt-4">
                                            <button
                                                type="button"
                                                className="btn btn-cancel"
                                                data-bs-dismiss="modal"
                                                onClick={handleReset}
                                            >
                                                Close
                                            </button>
                                            <div>
                                                <button
                                                    type="button"
                                                    className="btn btn-reset me-2"
                                                    onClick={handleReset}
                                                >
                                                    Reset
                                                </button>
                                                {(!name || !startDate || !endDate || (academic === null)) ? (
                                                    <button
                                                        type="button"
                                                        className="btn btn-submit"
                                                        onClick={handleSubmit}
                                                    >
                                                        {loading ? <Spin size="small" /> : "Save"}
                                                    </button>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        className="btn btn-submit"
                                                        onClick={handleSubmit}
                                                        data-bs-dismiss="modal"
                                                    >
                                                        {loading ? <Spin size="small" /> : "Save"}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

AddHolidays.propTypes = {
    onHolidayAdded: propTypes.func.isRequired
};

export default AddHolidays;